
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import SectionWriter from "./SectionWriter/SectionWriter.vue";
import PageStructureNew from "./PageStructure/PageStructureNew.vue";
import ImageEditor from "./ImageEditor/ImageEditor.vue";
import BackgroundImageEditor from "./BackgroundImageEditor/BackgroundImageEditor.vue";
import IconEditor from "./IconEditor/IconEditor.vue";
import TextEditor from "./TextEditor/TextEditor.vue";
import LinkEditor from "./LinkEditor/LinkEditor.vue";
import ContentPropertiesEditor from "./ContentPropertiesEditor/ContentPropertiesEditor.vue";
import HeaderAndFooterEditor from "./HeaderAndFooterEditor/HeaderAndFooterEditor.vue";
import WPPageManagerNew from "./WPPageManager/WPPageManagerNew.vue";
import BrandPanel from "./Brand/BrandPanel.vue";
import BrandPanelColorEdit from "./Brand/Color/BrandPanelColorEdit.vue";
import BrandPanelTypographyEdit from "./Brand/Typography/BrandPanelTypographyEdit.vue";
import { fetchBrandSettings } from "@/lib/singularity/brand/settings";
import NewSectionPanel from "./NewSectionPanel/NewSectionPanel.vue";
import RewriteSectionPanel from "./RewriteSection/RewriteSectionPanel.vue";

@Component({
  components: {
    SectionWriter,
    PageStructureNew,
    ImageEditor,
    BackgroundImageEditor,
    IconEditor,
    TextEditor,
    LinkEditor,
    ContentPropertiesEditor,
    HeaderAndFooterEditor,
    WPPageManagerNew,
    BrandPanel,
    BrandPanelColorEdit,
    BrandPanelTypographyEdit,
    NewSectionPanel,
    RewriteSectionPanel
  }
})
export default class SingularityLeftPanel extends Vue {
  get isLeftPanelHighlighted() {
    return singularityStore.singularityUiState
      .isSingularityLeftPanelHighlighted;
  }

  get singularityLeftPanelState() {
    return singularityStore.singularityUiState.singularityLeftPanel;
  }

  get imageEditorKey() {
    return singularityStore.imageEditorPanelState?.elementId || "no-image";
  }

  mounted() {
    fetchBrandSettings();
  }
}
